import { useFeatureFlags } from './useFeatureFlags';

export const useSkipOneDayEmailVerificationLatency = () => {
  const {
    flags: {
      useSkipOneDayEmailVerificationLatency:
        skipOneDayEmailVerificationLatencyFlagValue = false,
    },
  } = useFeatureFlags();
  return skipOneDayEmailVerificationLatencyFlagValue;
};
